import moment from 'moment';

export function sameDay(date1, date2) {
  return date1.getYear() === date2.getYear()
    && date1.getMonth() === date2.getMonth()
    && date1.getDate() === date2.getDate();
}

export function isToday(date){
  return sameDay(new Date(), date);
}

export function ftime(time) {
  return moment(time).zone('+0300').format('HH:mm');
}

export function fdate(date) {
  return moment(date).zone('+0300').format('MM/DD');
}


// WEBPACK FOOTER //
// ./src/utils/date.js